// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1P7wm","subheader":"ReorderModal_subheader__FOG6R","listWrap":"ReorderModal_listWrap__2toll"};